'use strict';
import { tns } from "tiny-slider"

class QuoteCarousel {
    constructor() {
        const hasSlider = document.querySelector('.quote-carousel__carousel');
        if (hasSlider) {
            tns({
                container: '.quote-carousel__carousel',
                slideBy: 'page',
                autoplay: window.autoScroll,
                autoplayTimeout: 8000,
                loop: true,
                controls: true,
                nav: true,
                speed: 400,
                mouseDrag: true,
                controlsText: ['', ''],
                onInit: function (instance) {
                    instance.nextButton.ariaLabel = "Framåt";
                    instance.prevButton.ariaLabel = "Bakåt";
                },
            });
        }
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new QuoteCarousel();
    const isCampaignPage = document.body.classList.contains('campaign');
    if (isCampaignPage) {
        const quoteCarousels = document.querySelectorAll('.quote-carousel');
        if (quoteCarousels) {
            quoteCarousels.forEach(quoteCarousel => {
                const tnsControls = quoteCarousel.querySelector('.tns-controls');
                if (tnsControls) {
                    const tnsNav = quoteCarousel.querySelector('.tns-nav');
                    let tnsNavPositionInfo = tnsNav.getBoundingClientRect();
                    let tnsNavWidth = tnsNavPositionInfo.width;
                    let tnsNavWidthGap = tnsNavWidth + 32;
                    tnsControls.style.gap = tnsNavWidthGap + 'px';
                }
            });
        }
    }
});